import React from 'react';
import { WebsiteImage } from 'components/TitleDescription';
import FeatureBrowseAll from 'components/Sections/FeatureBrowseAll';
import TestimonialCarousel from 'components/Sections/TestimonialCarousel';
import ContentBlockContainer from './ContentBlockContainer';
import colorTypeHelper from 'utils/colorTypeHelper';
import StyledRichText from 'components/RichText/StyledRichText';
import WistiaVideo from 'components/Core/WistiaVideo';

const ContentfulContentBlock = ({
  anchorId,
  heading,
  subhead,
  backgroundColor,
  collection,
  horizontalAlignment,
  ...otherProps
}) => {
  const type = collection?.length > 0 && collection[0].__typename;

  if (type === 'ContentfulTestimonial') {
    return (
      <TestimonialCarousel
        arrows
        backgroundColor={backgroundColor && colorTypeHelper[backgroundColor?.backgroundColor]}
        heading={heading}
        subhead={subhead}
        testimonials={collection}
        anchorId={anchorId}
      />
    );
  } else if (type === 'ContentfulImage') {
    return (
      <ContentBlockContainer
        backgroundColor={backgroundColor?.backgroundColor}
        heading={heading}
        subhead={subhead}
        anchorId={anchorId}
      >
        <div style={{ maxWidth: '840px', marginLeft: 'auto', marginRight: 'auto' }}>
          {collection?.map((ele, index) => {
            return (
              <WebsiteImage
                src={ele.image}
                alt={ele.alt}
                key={`content-block--website-image-${index}`}
              />
            );
          })}
        </div>
      </ContentBlockContainer>
    );
  } else if (type === 'ContentfulWistiaVideo') {
    return (
      <ContentBlockContainer
        backgroundColor={backgroundColor?.backgroundColor}
        heading={heading}
        subhead={subhead}
        anchorId={anchorId}
      >
        {collection?.map((ele, index) => {
          return (
            <WistiaVideo
              {...ele}
              key={index}
              size={ele?.size || 'Medium'}
              wrapperStyles={{ margin: '40px auto 0 auto' }}
            />
          );
        })}
      </ContentBlockContainer>
    );
  } else if (type === 'ContentfulInPageNavigation') {
    return (
      <FeatureBrowseAll
        background={backgroundColor?.backgroundColor}
        title={heading}
        features={collection}
        anchorId={anchorId}
      />
    );
  } else if (type === 'ContentfulRichText') {
    return (
      <ContentBlockContainer
        backgroundColor={backgroundColor?.backgroundColor}
        heading={heading}
        subhead={subhead}
        anchorId={anchorId}
      >
        {collection?.map((item, index) => (
          <StyledRichText key={index} content={item?.content?.json} />
        ))}
      </ContentBlockContainer>
    );
  }
  return null;
};

export default ContentfulContentBlock;
